const createEmptyStats = () => ({
    electronic_voted: 0,
    manual_voted: 0,
    ready: 0,
    ready_defaulting: 0,
    ready_disabled: 0,
    registered: 0,
    registered_defaulting: 0,
    registered_disabled: 0
});

export const adapterSnapshotData = (newData, electionId) => {
    const root = {
        _id: electionId,
        name: electionId,
        total_voters: 0,
        total_weighted: 0,
        voters: createEmptyStats(),
        weighted: createEmptyStats(),
        districts: {}
    };

    newData.forEach(item => {
        const {state, name, district_id, ballotbox_id} = item._id;
        const {count, weighted, factor} = item;

        root.voters[state] += count;
        root.weighted[state] += weighted;
        root.total_voters += count;
        root.total_weighted += weighted;

        if (!root.districts[district_id]) {
            root.districts[district_id] = {
                name,
                factor,
                voters: createEmptyStats(),
                weighted: createEmptyStats(),
                ballotboxes: {}
            };
        }

        const district = root.districts[district_id];
        district.voters[state] += count;
        district.weighted[state] += weighted;

        if (!district.ballotboxes[ballotbox_id]) {
            district.ballotboxes[ballotbox_id] = {
                name: 'mesa única',
                voters: createEmptyStats(),
                weighted: createEmptyStats()
            };
        }

        const ballotbox = district.ballotboxes[ballotbox_id];
        ballotbox.voters[state] += count;
        ballotbox.weighted[state] += weighted;
    });

    return root;
};

export const ensureLegacyFormat = (data, electionId) =>
    Array.isArray(data) ? adapterSnapshotData(data, electionId) : data;